import React from 'react';
import Main from 'components/OnboardingProcessNew';

const OnboardingProcessPage = props => {
  return <Main {...props} />;
};

// Props will be passed through to Main component
OnboardingProcessPage.propTypes = {};

OnboardingProcessPage.defaultProps = {};

export default OnboardingProcessPage;
